import React from "react";

import IconButton from "@material-ui/core/IconButton";
import Slide from "@material-ui/core/Slide";
import Snackbar from "@material-ui/core/Snackbar";
import CloseIcon from "@material-ui/icons/Close";
import PropTypes from "prop-types";

import RbSnackbarContext from "./RbSnackbarContext";

function SnackbarProvider(props) {
  const { children } = props;

  const [open, setOpen] = React.useState(false);

  const [options, setOptions] = React.useState({});

  const timeoutRef = React.useRef();

  const openSnackbar = React.useCallback((_options) => {
    setOptions(_options);
    setOpen(true);

    clearTimeout(timeoutRef.current);

    timeoutRef.current = setTimeout(() => {
      setOpen(false);
    }, 6000);
  }, []);

  const handleClose = React.useCallback(() => {
    clearTimeout(timeoutRef.current);
    setOpen(false);
  }, []);

  const contextValue = React.useMemo(() => {
    return {
      openSnackbar,
    };
  }, [openSnackbar]);

  React.useEffect(() => {
    return () => {
      clearTimeout(timeoutRef.current);
    };
  }, []);

  return (
    <RbSnackbarContext.Provider value={contextValue}>
      {children}
      <Snackbar
        TransitionComponent={Slide}
        anchorOrigin={{ vertical: "bottom", horizontal: "left" }}
        open={open}
        message={options.message}
        action={
          <IconButton aria-label="close" size="small" onClick={handleClose}>
            <CloseIcon style={{ fill: "gray" }} />
          </IconButton>
        }
      />
    </RbSnackbarContext.Provider>
  );
}

SnackbarProvider.propTypes = {
  children: PropTypes.node,
};

SnackbarProvider.defaultProps = {
  children: null,
};

export default SnackbarProvider;
